// React & Libraries
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

// UI Libraries
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import H3Image from '@Uilib/h3Image';

// Images
import ucIcon from '@Images/icons/unicommerce-icon.png';

// Helpers & constants
import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';
import { handleInvoiceDownload } from '../helper';

// Ant Design
import {
  notification, Popconfirm, Popover, Button, Tooltip, Menu, Dropdown,
} from 'antd';
import {
  LoadingOutlined, EditOutlined, ExclamationCircleFilled, WhatsAppOutlined, CopyOutlined
} from '@ant-design/icons';
import SubMenu from 'antd/es/menu/SubMenu';

// Immages
import Crown from '@Images/crown2.png';
import ShopifyIcon from '@Images/admin/integrations/shopify-icon.png';
import Busy from '@Images/admin/integrations/busy.png';
import TallyPrime from '@Images/admin/integrations/tally-prime.png';
import zohoIcon from '@Images/admin/integrations/zoho-books.png';

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faPrint } from '@fortawesome/free-solid-svg-icons';

// Common Components
import SelectCustomStatus from '../../../../Common/SelectCustomStatus';

// File specific components
import { addAlpha } from '../helper';

function ViewInvoiceLeftSectionHeader({
  props, state, updateState, enableLabelGeneration, isTallyConnected
}) {

  const {
    getInvoiceById, user, isQuickView, selectedInvoice, updateInvoiceStatusLoading, history, updateInvoiceStatus, pushInvoiceToBusy, deleteInvoiceLoading, deleteInvoice, callback, syncShopifySO, syncShopifySOLoading, syncInvoiceLoading, syncInvoice, syncTallyInvoiceLoading, syncTallyInvoice, showTriggerNode, downloadDocument,
  } = props;

  const {
    currentUpdate, isLabelAvailable, cancellationReason, currentInvId, currentTenantId,
  } = state;

  return (
    <div className="view-document__title">
      <div className="view-document__title-number-wrapper">
        <H3Text text={selectedInvoice?.invoice_number} className="view-document__title-number" />
        {selectedInvoice?.is_marketplace_invoice && (
          <div className="document-qr__status" style={{ backgroundColor: '#f58428' }}>
            MP
          </div>
        )}
      </div>

      <div className="view-document__title-actions">
        {selectedInvoice?.unicommerce_so_code && (
          <div className="action-buttons">
            <H3Text
              text={(
                <div className="unicommerce-icon-so">
                  <img alt="unicommerce" src={ucIcon} />
                </div>
              )}
              className="action-button action-button-big"
            />
          </div>
        )}
        <div className="action-buttons">
          {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.UPDATE, user)
            && !selectedInvoice?.unicommerce_so_code
            && selectedInvoice?.status?.toUpperCase() !== 'VOID'
            && !selectedInvoice?.shopify_order_id
            && !['CONFIRMED', 'VOID']?.includes(selectedInvoice?.status)
            && !selectedInvoice?.subcontractor_mo_id
            && (
              <H3Text
                text={(
                  <div onClick={() => {
                    if (selectedInvoice?.credit_notes?.length > 0 || selectedInvoice?.reference_dc?.length > 0) {
                      notification.error({
                        message: 'Sorry, you are not allowed to edit a invoice for which credit note / delivery challan has been created.',
                        placement: 'top',
                        duration: 4,
                      });
                      updateState({ cancellationPop: false });
                    } else if (selectedInvoice?.e_invoice_status === 'PUSHED') {
                      notification.open({
                        message: 'Please cancel the e-Invoice before updating this invoice',
                        duration: 6,
                        placement: 'top',
                        type: 'error',
                      });
                    } else {
                      history.push(`/sales/invoices/update/${selectedInvoice?.invoice_id}`);
                    }
                  }}
                  >
                    <EditOutlined />
                  </div>
                )}
                className="action-button hide__in-mobile"
              />
            )}

          {user?.tenant_info?.integration_config?.sub_modules?.whatsapp?.is_active && user?.tenant_info?.integration_tenant_whatsapp_id && Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.UPDATE, user) && (selectedInvoice?.status !== 'DRAFT') && (
            <H3Text
              text={(
                <div onClick={() => updateState({ showWhatsappDrawer: true })}>
                  <WhatsAppOutlined />
                </div>
              )}
              className="action-button"
            />
          )}

          <Dropdown
            getPopupContainer={(triggerNode) => (isQuickView && triggerNode.parentNode ? triggerNode.parentNode : document.body)}
            overlay={(
              <Menu style={{ width: '260px' }}>
                {selectedInvoice?.org_currency_info?.org_currency_id && (
                  <SubMenu title={`Invoice (${selectedInvoice?.org_currency_info?.currency_code})`}>
                    <Menu.Item
                      key="invoice-pdf"
                      onClick={() => handleInvoiceDownload({
                        updateState,
                        user,
                        selectedInvoice,
                        downloadDocument,
                      })}
                    >
                      Download PDF
                    </Menu.Item>
                    <Menu.Item
                      key="invoice-excel"
                      onClick={() => handleInvoiceDownload({
                        isExcel: true,
                        updateState,
                        user,
                        selectedInvoice,
                        downloadDocument,
                      })}
                    >
                      Download Excel
                    </Menu.Item>
                  </SubMenu>
                )}
                {selectedInvoice?.base_currency_info?.org_currency_id && (selectedInvoice?.org_currency_info?.org_currency_id !== selectedInvoice?.base_currency_info?.org_currency_id) && (
                  <SubMenu title={`Invoice (${selectedInvoice?.base_currency_info?.currency_code})`}>
                    <Menu.Item
                      key="invoice-base-pdf"
                      onClick={() => handleInvoiceDownload({
                        inBaseCurrency: true,
                        updateState,
                        user,
                        selectedInvoice,
                        downloadDocument,
                      })}
                    >
                     Download PDF
                    </Menu.Item>
                    <Menu.Item
                      key="invoice-base-excel"
                      onClick={() => handleInvoiceDownload({
                        isExcel: true,
                        inBaseCurrency: true,
                        updateState,
                        user,
                        selectedInvoice,
                        downloadDocument,
                      })}
                    >
                     Download Excel
                    </Menu.Item>
                  </SubMenu>
                )}
                <Menu.Item>
                  <H3Text
                    text="Invoice With tax analysis report"
                    onClick={() => {
                      updateState({ includeEWayBill: false });
                      user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings
                        .allow_invoice_to_print_multiple_copies ? updateState({ isModalOpen: true, downloadDocumentInBaseCurrency: true, downloadInvoiceWithTaxReport: true })
                        : downloadDocument({
                          url: `${Constants.Invoice}/download?invoice_id=${selectedInvoice?.invoice_id}&tenant_id=${selectedInvoice?.tenant_id}&include_eWay_bill=false&download_document_in_base_currency=true&required_tax_analysis_report=true`,
                          document_type: 'INVOICE',
                          document_number: selectedInvoice?.invoice_number,
                          key: uuidv4(),
                        });
                    }}
                    className="hide__in-mobile"
                  />
                </Menu.Item>
                <Menu.Item>
                  <H3Text
                    text="Invoice With e-way bill"
                    onClick={() => {
                      updateState({ includeEWayBill: true });
                      user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings
                        .allow_invoice_to_print_multiple_copies ? updateState({ isModalOpen: true, includeEWayBill: true, eWayBillType: 'pdf', downloadInvoiceWithTaxReport: false })
                        : downloadDocument({
                          url: `${Constants.Invoice}/download?invoice_id=${selectedInvoice?.invoice_id}&tenant_id=${selectedInvoice?.tenant_id}&include_eWay_bill=true&ewb_type=pdf`,
                          document_type: 'INVOICE',
                          document_number: selectedInvoice?.invoice_number,
                          key: uuidv4(),
                        });
                    }}
                    className="hide__in-mobile"
                  />
                </Menu.Item>
                <Menu.Item>
                  <H3Text
                    text="Invoice with detailed e-way bill"
                    onClick={() => {
                      updateState({ includeEWayBill: true });
                      user?.tenant_info?.sales_config?.sub_modules?.invoice?.settings
                        .allow_invoice_to_print_multiple_copies ? updateState({ isModalOpen: true, includeEWayBill: true, eWayBillType: 'detailed_pdf', downloadInvoiceWithTaxReport: false })
                        : downloadDocument({
                          url: `${Constants.Invoice}/download?invoice_id=${selectedInvoice?.invoice_id}&tenant_id=${selectedInvoice?.tenant_id}&include_eWay_bill=true&ewb_type=detailed_pdf`,
                          document_type: 'INVOICE',
                          document_number: selectedInvoice?.invoice_number,
                          key: uuidv4(),
                        });
                    }}
                    className="hide__in-mobile"
                  />
                </Menu.Item>
                {selectedInvoice?.irn && (
                  <Menu.Item>
                    <H3Text
                      text="e-invoice"
                      onClick={() => downloadDocument({
                        url: `${Constants.DOWNLOAD_E_INVOICE}?irn=${selectedInvoice?.irn}&tenant_id=${selectedInvoice?.tenant_id}`,
                        document_type: 'E-Invoice',
                        document_number: selectedInvoice?.invoice_number,
                        key: uuidv4(),
                      })}
                      className="hide__in-mobile"
                    />
                  </Menu.Item>
                )}
                <Menu.Item>
                  <H3Text
                    text="Shipping Label"
                    className="hide__in-mobile"
                    onClick={() => downloadDocument({
                      url: `${Constants.DOWNLOAD_SHIPPING_LABELS}/download?invoice_id=${selectedInvoice?.invoice_id}`,
                      document_type: 'SHIPPING_LABEL',
                      document_number: selectedInvoice?.invoice_number,
                      key: uuidv4(),
                    })}
                  />
                </Menu.Item>
                <Menu.Item>
                  <H3Text
                    text="Shipping Label with Price"
                    className="hide__in-mobile"
                    onClick={() => downloadDocument({
                      url: `${Constants.DOWNLOAD_SHIPPING_LABELS}/download?invoice_id=${selectedInvoice?.invoice_id}&with_price=true`,
                      document_type: 'SHIPPING_LABEL',
                      document_number: selectedInvoice?.invoice_number,
                      key: uuidv4(),
                    })}
                  />
                </Menu.Item>
                <Menu.Item>
                  <div style={{ display: `${!enableLabelGeneration ? 'flex' : 'block'}`, alignItems: 'center' }}>
                    <H3Text
                      text="Generate Labels"
                      onClick={() => {
                        if (enableLabelGeneration) {
                          if (!isLabelAvailable) {
                            notification.open({
                              type: 'error',
                              message: 'No Label format is available for Invoice to download',
                              duration: 4,
                              placement: 'top',
                            });
                          } else {
                            updateState({ isGenerateLabelModalOpen: true });
                          }
                        }
                      }}
                    />
                    {!enableLabelGeneration
                      && (
                        <Popconfirm
                          placement="topRight"
                          title="This feature is not accessible within your current plan to use this feature contact us."
                          onConfirm={() => window.Intercom('showNewMessage')}
                          okText="Contact Us"
                          cancelText="Cancel"
                        >
                          <img
                            className="barcode-restrict"
                            src={Crown}
                            alt="premium"
                            style={{
                              marginLeft: '8px',
                            }}
                          />
                        </Popconfirm>
                      )}
                  </div>
                </Menu.Item>

              </Menu>
            )}
            trigger={['click']}
            placement={isQuickView ? 'topRight' : 'bottomLeft'}
          >
            <div className="action-button " onClick={(e) => e.preventDefault()}>
              <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
            </div>

          </Dropdown>
          {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.CREATE, user) && !selectedInvoice?.shopify_order_id && !selectedInvoice?.unicommerce_so_code && (
            <Tooltip
              placement="topLeft"
              title="Make a Copy"
            >
              <CopyOutlined
                className="action-button"
                style={{
                  justifyContent: 'center',
                  fontSize: '16px',
                }}
                onClick={() => {
                  history.push({
                    pathname: '/sales/invoices/create',
                    state: { cloneInv: selectedInvoice?.invoice_id, selectedTenantIdInv: selectedInvoice?.tenant_id },
                  });
                }}
              />
            </Tooltip>
          )}
        </div>
        {(selectedInvoice?.unicommerce_so_code) && (
          <div className="action-buttons">
            {user?.tenant_info?.sales_config?.sub_modules?.credit_note?.is_active && Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.CREATE, user) && selectedInvoice?.invoice_grand_total - selectedInvoice?.credits_applied > 0 && (

              <H3Text
                text="+ Credit Note"
                className="action-button action-button-big"
                onClick={() => updateState({ showCNForm: true })}
              />

            )}
          </div>
        )}
        {(!selectedInvoice?.unicommerce_so_code) && (
          <div className="action-buttons">
            {/* Cancel Order Action */}
            {selectedInvoice?.status?.toLowerCase() !== 'void' && Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.UPDATE, user) && !selectedInvoice?.shopify_order_id && (
              <Popover
                placement="topRight"
                title="Are you sure you want to cancel?"
                content={(
                  <React.Fragment>
                    <H3FormInput
                      name="cancellation reason"
                      type="text"
                      containerClassName="orgInputContainer create__right-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      onChange={(event) => updateState({ cancellationReason: event.target.value })}
                      value={cancellationReason}
                      label="Reason"
                      maxlength="100"
                      required
                      showError={currentUpdate === 'VOID' && !cancellationReason}
                    />
                    <div
                      className="view-document__cancellation-buttons"
                    >
                      <Button
                        disabled={selectedInvoice?.credit_notes?.length || selectedInvoice?.e_invoice_status === 'PUSHED'}
                        onClick={() => {
                          updateState({ currentUpdate: 'VOID' });
                          if (selectedInvoice?.credit_notes?.length > 0) {
                            notification.error({
                              message: 'Sorry, you are not allowed to cancel an invoice for which a credit note has been created.',
                              placement: 'top',
                              duration: 6,
                            });
                          } else if (selectedInvoice?.e_invoice_status === 'PUSHED') {
                            notification.open({
                              message: 'Please cancel the e-Invoice before cancelling this invoice',
                              duration: 6,
                              placement: 'top',
                              type: 'error',
                            });
                          } else if (cancellationReason) {
                            updateInvoiceStatus({
                              status: 'VOID',
                              invoice_id: currentInvId,
                              cancellation_reason: cancellationReason,
                            }, () => {
                              if (callback) {
                                callback();
                              } else {
                                getInvoiceById(user?.tenant_info?.org_id, currentTenantId, currentInvId);
                                updateState({ currentUpdate: '' });
                                updateState({ cancellationPop: false });
                              }
                            });
                          }
                        }}
                        type="primary"
                        size="small"
                      >
                        Cancel
                      </Button>
                    </div>
                  </React.Fragment>
                )}
                trigger="click"
              >
                <H3Text
                  text={(
                    <div style={{ width: '50px', textAlign: 'center' }}>
                      {(updateInvoiceStatusLoading && currentUpdate === 'VOID')
                        ? <LoadingOutlined /> : (
                          <span>Cancel</span>
                        )}
                    </div>
                  )}
                  onClick={() => {
                    const creditNoteErrorMessage = selectedInvoice?.credit_notes?.length > 0
                      ? 'Sorry, you are not allowed to cancel an invoice for which a credit note has been created.'
                      : null;
                    const paymentErrorMessage = selectedInvoice?.payment_status === 'PAID'
                      ? 'Sorry, you are not allowed to cancel an invoice for which payment has been created.'
                      : null;
                    const referenceErrorMessage = selectedInvoice?.reference_dc?.length > 0
                      ? 'Sorry, you are not allowed to cancel an invoice for which delivery challans have been created.'
                      : null;

                    const errorMessage = creditNoteErrorMessage || paymentErrorMessage || referenceErrorMessage;

                    if (errorMessage) {
                      notification.error({
                        message: errorMessage,
                        placement: 'top',
                        duration: 4,
                      });
                      updateState({ cancellationPop: false });
                    } else {
                      updateState({ cancellationPop: true });
                    }
                  }}
                  className="action-button action-button-big"
                />
              </Popover>
            )}

            {/* Delete Order Action */}
            {selectedInvoice?.status?.toLowerCase() !== 'sent_for_approval' && Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.DELETE, user) && !selectedInvoice?.shopify_order_id && (
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete the invoice?"
                onConfirm={() => {
                  if (selectedInvoice?.credit_notes?.length > 0) {
                    notification.error({
                      message: 'Sorry, you are not allowed to delete a invoice for which credit note has been created.',
                      placement: 'top',
                      duration: 4,
                    });
                  } else if (selectedInvoice?.e_invoice_status === 'PUSHED') {
                    notification.open({
                      message: 'Please cancel the e-Invoice before deleting this invoice',
                      duration: 6,
                      placement: 'top',
                      type: 'error',
                    });
                  } else {
                    deleteInvoice({
                      tenant_id: selectedInvoice?.tenant_id,
                      invoice_id: currentInvId,
                    }, () => {
                      if (callback) {
                        callback();
                      } else {
                        history.push('/sales/invoices');
                      }
                    });
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={(
                    <div>
                      {deleteInvoiceLoading ? <LoadingOutlined /> : (
                        <span>Delete</span>
                      )}
                    </div>
                  )}
                  className="action-button action-button-big"
                />
              </Popconfirm>
            )}
            {/* Shopify Sync Action */}
            {['ISSUED'].includes(selectedInvoice?.status) && (
              <H3Text
                className="action-button action-button-big"
                onClick={() => {
                  if (!syncShopifySOLoading) {
                    syncShopifySO(
                      { shopify_order_id: selectedInvoice?.shopify_order_id },
                      () => {
                        getInvoiceById(user?.tenant_info?.org_id, currentTenantId, currentInvId);
                      },
                    );
                  }
                }}
                text={(
                  <React.Fragment>
                    {!syncShopifySOLoading ? (
                      <React.Fragment>
                        <H3Image src={ShopifyIcon} className="action-menu-shopify-icon" />
                        <H3Text text="Sync" className="action-menu-button" />
                      </React.Fragment>
                    )
                      : <LoadingOutlined />}
                  </React.Fragment>
                )}
              />
            )}
            {selectedInvoice?.status === 'CONFIRMED'
              && !window.location.href.includes('sales/sales-order/view')
              && (
                <Dropdown
                  {...(showTriggerNode
                    ? { getPopupContainer: (triggerNode) => triggerNode.parentNode }
                    : {})}
                  overlay={(
                    <div style={{ width: '183px' }}>
                      <Menu>
                        {!selectedInvoice?.e_way_bills?.filter((rec) => rec?.status === 'GENERATED')?.length && !selectedInvoice?.shopify_order_id && user?.tenant_info?.is_e_way_bill_enabled && (
                          <Menu.Item>
                            <H3Text
                              text={(
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div>
                                    + e-Way Bill
                                  </div>
                                  {!user?.tenant_info?.sales_config?.addons?.e_waybill?.is_active && (
                                    <Popconfirm
                                      placement="topRight"
                                      title="This feature is not accessible within your current plan to use this feature contact us."
                                      onConfirm={() => window.Intercom('showNewMessage')}
                                      okText="Contact Us"
                                      cancelText="Cancel"
                                    >
                                      <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                    </Popconfirm>
                                  )}
                                </div>
                              )}
                              className="hide__in-mobile"
                              onClick={() => updateState({ showEWaybillFormDrawer: true })}
                            />
                          </Menu.Item>
                        )}
                        {user?.tenant_info?.sales_config?.sub_modules?.credit_note?.is_active && Helpers.getPermission(Helpers.permissionEntities.CREDIT_NOTE, Helpers.permissionTypes.CREATE, user) && selectedInvoice?.invoice_grand_total - selectedInvoice?.credits_applied > 0 && (
                          <Menu.Item>
                            <H3Text
                              text="+ Credit Note"
                              className="hide__in-mobile"
                              onClick={() => updateState({ showCNForm: true })}
                            />
                          </Menu.Item>
                        )}
                        {Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.CREATE, user) && !selectedInvoice?.shopify_order_id && selectedInvoice?.delivery_challan_id === null && (
                          <Menu.Item>
                            <H3Text
                              text={(
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div>
                                    + Delivery Challan
                                  </div>
                                  {!user?.tenant_info?.inventory_config?.sub_modules?.delivery_challan?.is_active && (
                                    <Popconfirm
                                      placement="topRight"
                                      title="This feature is not accessible within your current plan to use this feature contact us."
                                      onConfirm={() => window.Intercom('showNewMessage')}
                                      okText="Contact Us"
                                      cancelText="Cancel"
                                    >
                                      <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                    </Popconfirm>
                                  )}
                                </div>
                              )}
                              className="hide__in-mobile"
                              onClick={() => updateState({ showDCDrawer: true })}
                            />
                          </Menu.Item>
                        )}
                        {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.CREATE, user) && (
                          <Menu.Item>
                            <H3Text
                              text={(
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div>
                                    Record Payment
                                  </div>
                                  {!user?.tenant_info?.sales_config?.sub_modules?.payment_incoming?.is_active && (
                                    <Popconfirm
                                      placement="topRight"
                                      title="This feature is not accessible within your current plan to use this feature contact us."
                                      onConfirm={() => window.Intercom('showNewMessage')}
                                      okText="Contact Us"
                                      cancelText="Cancel"
                                    >
                                      <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                    </Popconfirm>
                                  )}
                                </div>
                              )}
                              onClick={() => {
                                if (user?.tenant_info?.sales_config?.sub_modules?.payment_incoming?.is_active) {
                                  updateState({ showPayment: true });
                                }
                              }}
                              className="hide__in-mobile"
                            />
                          </Menu.Item>
                        )}
                        {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER_PAYMENTS, Helpers.permissionTypes.CREATE, user) && window.screen.width > 425 && (
                          <Menu.Item>
                            <H3Text
                              text={(
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div>
                                    Link Payment
                                  </div>
                                  {!user?.tenant_info?.sales_config?.sub_modules?.payment_incoming?.is_active && (
                                    <Popconfirm
                                      placement="topRight"
                                      title="This feature is not accessible within your current plan to use this feature contact us."
                                      onConfirm={() => window.Intercom('showNewMessage')}
                                      okText="Contact Us"
                                      cancelText="Cancel"
                                    >
                                      <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                    </Popconfirm>
                                  )}
                                </div>
                              )}
                              onClick={() => {
                                if (user?.tenant_info?.sales_config?.sub_modules?.payment_incoming?.is_active) {
                                  updateState({ linkPayment: true });
                                }
                              }}
                              className="hide__in-mobile"
                            />
                          </Menu.Item>
                        )}
                        {selectedInvoice?.integration_busy_config?.status === 'CONNECTED' && ['CONFIRMED'].includes(selectedInvoice?.status) && (
                          <Menu.Item>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >

                              <H3Image
                                src={Busy}
                                className="action-menu-button-icon"
                                style={{
                                  borderRadius: '20%',
                                  width: '20px',
                                }}
                              />
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      Push To Busy
                                    </div>
                                    {!user?.tenant_info?.purchase_config?.addons?.request_for_quotation?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => window.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                onClick={() => pushInvoiceToBusy({
                                  invoice_id: selectedInvoice?.invoice_id,
                                }, () => {
                                  getInvoiceById(user?.tenant_info?.org_id, currentTenantId, currentInvId);
                                })}
                                className="hide__in-mobile"
                              />
                            </div>
                          </Menu.Item>
                        )}
                        {/* Sync Tally Action */}
                        {isTallyConnected && (
                          <Menu.Item>
                            <Popconfirm
                              placement="topRight"
                              title={(selectedInvoice?.tally_warning_message ? selectedInvoice?.tally_warning_message : (selectedInvoice?.tally_updated_at ? ' Invoice is already synced with tally' : ' Invoice is not synced with tally'))}
                              onConfirm={() => syncTallyInvoice(
                                { invoice_id: selectedInvoice?.invoice_id, override_creation: false },
                                () => { getInvoiceById(user?.tenant_info?.org_id, currentTenantId, currentInvId); },
                              )}
                              okText={(!selectedInvoice?.tally_warning_message && !selectedInvoice?.tally_updated_at) ? 'Sync' : 'Sync Again'}
                              okButtonProps={{ loading: syncTallyInvoiceLoading }}
                              cancelText="Cancel"
                              icon={selectedInvoice?.tally_warning_message ? <ExclamationCircleFilled style={{ color: '#F2BD27' }} /> : <React.Fragment />}
                            >
                              <div className="action-button action-button-big action-button-tally" style={{ display: 'flex', alignItems: 'center' }}>
                                <img
                                  src={TallyPrime}
                                  alt="Tally"
                                  className="action-menu-zoho-icon"
                                />
                                <H3Text text="Sync Tally" className="action-menu-button" />
                              </div>
                            </Popconfirm>
                          </Menu.Item>
                        )}
                        {/* Sync Zoho Action */}
                        {!['DRAFT', 'VOID', 'REJECTED', 'CANCELLED', 'SENT_FOR_APPROVAL'].includes(selectedInvoice?.status) && user?.user_tenants?.find((item) => item?.tenant_id === selectedInvoice?.tenant_id)?.zoho_branch_id && (
                          <Menu.Item>
                            <div
                              style={{ width: '80px' }}
                              className="action-button-tally action-button-big"
                              onClick={() => {
                                if (!syncInvoiceLoading) {
                                  syncInvoice(
                                    { invoice_id: selectedInvoice?.invoice_id },
                                    () => {
                                      getInvoiceById(user?.tenant_info?.org_id, currentTenantId, currentInvId);
                                    },
                                  );
                                }
                              }}
                            >
                              {!syncInvoiceLoading ? (
                                <React.Fragment>
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <H3Image src={zohoIcon} className="action-menu-zoho-icon" />
                                    <H3Text text="Sync Zoho" className="action-menu-button" />
                                  </div>
                                </React.Fragment>
                              )
                                : <LoadingOutlined />}
                            </div>
                          </Menu.Item>
                        )}
                      </Menu>
                    </div>
                  )}
                  trigger={['click']}
                  overlayStyle={{ width: '90px' }}
                  placement="topRight"
                >
                  <div style={{ width: '90px', borderRight: 'none', whiteSpace: 'nowrap' }} className="action-button action-button-big" onClick={(e) => e.preventDefault()}>
                    More &nbsp;
                    <FontAwesomeIcon icon={faCaretDown} />
                  </div>
                </Dropdown>
              )}
            {Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.UPDATE, user) && selectedInvoice?.custom_status_info?.type !== 'VOID' && (
              <SelectCustomStatus
                selectedCustomStatus={selectedInvoice?.custom_status_id}
                hideTitle
                tenantId={selectedInvoice?.tenant_id}
                posibleStatuses={[selectedInvoice?.custom_status_info, ...selectedInvoice?.possible_status ?? []]}
                onChange={(value) => {
                  updateInvoiceStatus({
                    status: value?.type,
                    secondary_status: value?.status_name,
                    invoice_id: selectedInvoice?.invoice_id,
                    custom_status_id: value?.custom_status_id,
                  }, () => {
                    getInvoiceById(user?.tenant_info?.org_id, currentTenantId, currentInvId);
                  });
                }}
                disabled={['VOID', 'SENT_FOR_APPROVAL']?.includes(selectedInvoice?.custom_status_info?.type)}
                customStyle={{
                  color: selectedInvoice?.custom_status_info?.color_code,
                  backgroundColor: addAlpha(selectedInvoice?.custom_status_info?.color_code, 1),
                  height: '35px',
                }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewInvoiceLeftSectionHeader;